<script setup lang="ts">
import EmailPanelSection from '../EmailPanelSection.vue'
import ColorPickerWithPresets from '../ColorPickerWithPresets.vue'
import type { SeparatorBlock } from '../../types'

const { t } = useI18n()

const props = defineProps<{
  block: SeparatorBlock
  colorPresets?: { color: string; label: string }[]
}>()

const emit = defineEmits<{
  (e: 'update:block', block: SeparatorBlock): void
}>()

const updateColor = (color: string) => {
  emit('update:block', { ...props.block, color })
}

const updateBackgroundColor = (blockBackgroundColor: string) => {
  emit('update:block', { ...props.block, blockBackgroundColor })
}

const updateHeight = (height: number) => {
  emit('update:block', { ...props.block, height })
}
</script>

<template>
  <Teleport to="#email-settings-panel" defer>
    <div class="space-y-8 px-4 pb-6 pt-4">
      <EmailPanelSection :title="t('pages.email.emailTemplateCreatePage.panel.blockBackground')">
        <ColorPickerWithPresets
          :model-value="block.blockBackgroundColor ?? 'ffffff'"
          :presets="colorPresets ?? []"
          @update:model-value="updateBackgroundColor"
        />
      </EmailPanelSection>

      <EmailPanelSection :title="t('pages.email.emailTemplateCreatePage.panel.color')">
        <ColorPickerWithPresets
          :model-value="block.color"
          :presets="colorPresets ?? []"
          @update:model-value="updateColor"
        />
      </EmailPanelSection>

      <EmailPanelSection :title="t('pages.email.emailTemplateCreatePage.panel.height')">
        <div class="space-y-2">
          <div class="flex items-center justify-between">
            <Label class="text-xs font-medium text-foreground">
              {{ t('pages.email.emailTemplateCreatePage.panel.height') }}
            </Label>
            <span class="text-[11px] tabular-nums text-muted-foreground">{{ block.height }}px</span>
          </div>
          <Slider :model-value="[block.height]" :min="8" :max="48" @update:model-value="(v) => updateHeight(v[0])" />
        </div>
      </EmailPanelSection>
    </div>
  </Teleport>
</template>
